import { render, staticRenderFns } from "./toggleDetail.vue?vue&type=template&id=e5184238"
import script from "./toggleDetail.vue?vue&type=script&lang=js"
export * from "./toggleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports